import { object, string } from "yup";

export const moveOutDateValidations = (minDate?: string) =>
  object({
    movedOutDate: string()
      .required("Move out date is required")
      .test(
        "must_be_before_today",
        "Move out date must be before today.",
        function (value) {
          return new Date(value) < new Date();
        }
      )
      .test(
        "must_be_after_min_date",
        `Move out date must be after ${minDate}.`,
        function (value) {
          return new Date(value) > new Date(String(minDate));
        }
      )
  });

export const leaseDetailsValidations = object({
  leaseEndDate: string().required("Lease end date is required"),
  rentAmount: string()
    .test(
      "must_be_at_least_$100",
      "Monthly rent must be at least $100",
      function (value) {
        return Number(value) > 100;
      }
    )
    .test(
      "must_be_less_than_$8,000",
      "Monthly rent must be less than $8,000",
      function (value) {
        return Number(value) < 8000;
      }
    )
});

export const rentAmountValidations = object({
  rentAmount: string()
    .test(
      "must_be_at_least_$100",
      "Monthly rent must be at least $100",
      function (value) {
        return Number(value) > 100;
      }
    )
    .test(
      "must_be_less_than_$8,000",
      "Monthly rent must be less than $8,000",
      function (value) {
        return Number(value) < 8000;
      }
    )
});
